import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { bucketApi } from '~/supabase/bucket/api'

export const useGetModelPhotos = () => {
  return useMutation({
    mutationKey: ['get-model-photos'],
    mutationFn: async (params: Parameters<typeof bucketApi.getModelPhotos>[number]) =>
      await bucketApi.getModelPhotos(params),
    onError: (err) => {
      toast.error('Failed to get the model image')
      console.error(err)
    },
  })
}
